import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
type ImgProps = {
  filename: string
  alt: string
  className?: string
  Tag?: string
  style?: any
}

const Image: React.FC<ImgProps> = ({
  alt,
  className,
  filename,
  Tag = "div",
  style,
  ...rest
}) => (
  <StaticQuery
    query={graphql`
      query {
        images: allFile(
          filter: {
            childImageSharp: { original: { src: { regex: "/(png)|(jpg)/" } } }
          }
        ) {
          edges {
            node {
              relativePath
              name
              childImageSharp {
                fluid(quality: 100) {
                  ...GatsbyImageSharpFluid_noBase64
                  presentationWidth
                  presentationHeight
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const image = data.images.edges.find(n => {
        return n.node.relativePath.includes(filename)
      })

      if (!image) {
        return null
      }

      const props = { alt, className, Tag, style, ...rest }

      const fluid = image.node.childImageSharp.fluid

      let normalizedProps = { ...props, fluid }
      if (fluid && fluid.presentationWidth && fluid.presentationWidth) {
        normalizedProps = {
          ...props,
          fluid,
          style: {
            maxWidth: fluid.presentationWidth,
            maxHeight: fluid.presentationHeight,
            width: "100%",
            ...(props.style || {}),
          },
        }
      }
      return <Img {...normalizedProps} />
    }}
  />
)
export default Image
